// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"


// MAKE BOOTSTRAP GLOBAL
window.bootstrap = bootstrap
